import { motion } from "framer-motion";
import { Baby, Users, Network, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { HexIcon } from "@/components/HexIcon";

const services = [
  {
    icon: Baby,
    title: "Maternal Support",
    body: "Prenatal & postpartum guidance, baby supplies, and steady emotional support for expecting and new mothers — from first appointment to first steps.",
    testid: "service-card-maternal-support",
  },
  {
    icon: Users,
    title: "Family Resources",
    body: "Essential household items, emergency aid, parent education, and family stabilization assistance to keep homes strong and secure.",
    testid: "service-card-family-resources",
  },
  {
    icon: Network,
    title: "Community Referrals",
    body: "Warm hand-offs to trusted local health, housing, legal, and financial assistance programs — we walk with you until you're connected.",
    testid: "service-card-community-referrals",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="honeycomb-light relative bg-cream-deep py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.24em] text-gold-deep" data-testid="services-eyebrow">
            Chapter 02 — What We Offer
          </p>
          <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-testid="services-heading">
            Support for every season <span className="italic text-gold-deep">of family life.</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink-soft" data-testid="services-subtext">
            Every service is free, confidential, and rooted in relationship. Come as you are — leave connected.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 260, damping: 20 }}
                className="group soft-shadow flex h-full flex-col rounded-[1.75rem] border border-transparent bg-white p-7 transition-colors duration-500 hover:border-gold/50"
                data-testid={s.testid}
              >
                <HexIcon size={64}>
                  <s.icon size={26} strokeWidth={1.8} />
                </HexIcon>
                <h3 className="mt-6 font-display text-xl font-semibold text-ink">{s.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-ink-soft">{s.body}</p>
                <div className="mt-6 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-gold-deep opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  Learn how it works
                  <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
